import SurveyTrackerProfile from './SurveyTrackerProfile.vue';

export default SurveyTrackerProfile;
